import { buildCallsGovernorExecutiveBridgeReport } from "@/governor/activation/CallsGovernorExecutiveBridge";

const EVENT_KEY = "kinscircle_governor_runtime_events";

export function activateCallsGovernorRuntime() {
  const report = buildCallsGovernorExecutiveBridgeReport();

  const event = {
    type: "calls_governor_runtime_activation",
    governorId: "calls",
    executiveAware: report.executiveAware,
    active: report.active,
    maturity: report.maturity,
    inventoryStatus: report.inventoryStatus,
    evidence: report.evidence,
    timestamp: new Date().toISOString(),
  };

  if (typeof window !== "undefined") {
    try {
      let existing: unknown[] = [];

      try {
        const parsed = JSON.parse(localStorage.getItem(EVENT_KEY) || "[]");
        existing = Array.isArray(parsed) ? parsed : [];
      } catch {
        existing = [];
      }

      localStorage.setItem(
        EVENT_KEY,
        JSON.stringify([...existing, event].slice(-100))
      );
    } catch (error) {
      console.warn("Calls Governor runtime storage bypassed.", error);
    }

    try {
      window.dispatchEvent(
        new CustomEvent("kinscircle:governor-runtime-event", { detail: event })
      );
    } catch (error) {
      console.warn("Calls Governor runtime dispatch bypassed.", error);
    }
  }

  return event;
}

export const CALLS_GOVERNOR_RUNTIME_ACTIVATION_READY = true;

// Auto-start once per browser session when this module is imported by AppLayout.
if (typeof window !== "undefined") {
  try {
    const flag = "kinscircle_calls_governor_runtime_activation_started";
    if (!sessionStorage.getItem(flag)) {
      sessionStorage.setItem(flag, "true");
      setTimeout(() => activateCallsGovernorRuntime(), 0);
    }
  } catch {
    setTimeout(() => activateCallsGovernorRuntime(), 0);
  }
}
